import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import axios from "axios";
import Loading from 'quasar/src/plugins/Loading.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload"; // Init state

var initState = function initState() {
  return {
    status: ""
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  loginUser: function loginUser(_ref, user) {
    var _this = this;

    var commit = _ref.commit;
    Loading.show();
    axios.post("/auth/login", user).then(function (response) {
      Loading.hide();
      LocalStorage.set("loggedIn", true);

      _this.$router.push({
        name: "organizations"
      });
    }).catch(function (error) {
      LocalStorage.set("loggedIn", false);
      errorDialog.showErrorMessageFromServer(getErrorPayload(error));
      console.log("error.response: ", error.response);
    });
  },
  registerUser: function registerUser(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    Loading.show();
    axios.post("/auth/register", payload).then(function () {
      Loading.hide();
      LocalStorage.set("loggedIn", true);

      _this2.$router.push({
        name: "organizations"
      });
    }).catch(function (error) {
      LocalStorage.set("loggedIn", false);
      errorDialog.showErrorMessageFromServer(getErrorPayload(error));
      console.log("error.response: ", error.response);
    });
  },
  loginGoogle: function loginGoogle() {
    axios.get("/auth/login/redirect/google").then(function (response) {
      if (response.data.redirect_url) {
        window.location.href = response.data.redirect_url;
      }
    });
  },
  loginLinkedin: function loginLinkedin() {
    axios.get("/auth/login/redirect/linkedin").then(function (response) {
      if (response.data.redirect_url) {
        window.location.href = response.data.redirect_url;
      }
    });
  },
  logout: function logout() {
    var _this3 = this;

    Loading.show();
    axios.post("/auth/logout").then(function () {
      Loading.hide();
      LocalStorage.set("loggedIn", false);

      _this3.$router.push("/auth");

      _this3.dispatch("resetAll");
    }).catch(function (error) {
      console.log("This is not good, i can't log out?: ", error.response);
    });
  },
  sendRecoverPasswordLink: function sendRecoverPasswordLink(_ref3, request) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      axios.post("/auth/password/email", request).then(function () {
        resolve();
      }).catch(function (error) {
        var _error$response;

        if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 422) {
          var _error$response2, _error$response2$data;

          reject((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.errors) || {});
        }
      });
    });
  },
  passwordReset: function passwordReset(_ref4, request) {
    var _this4 = this;

    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      axios.post("/auth/password/reset", request).then(function () {
        Loading.hide();
        LocalStorage.set("loggedIn", true);

        _this4.$router.push({
          name: "organizations"
        });
      }).catch(function (error) {
        var _error$response3;

        if ((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 422) {
          var _error$response4, _error$response4$data;

          reject((error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.errors) || {});
        }
      });
    });
  }
}; // Getter functions

var getters = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};